import { SET_HEADER_STATE } from "core-web/state/models/Header/constants";
import store from "core-web/state/store";

export const setHeaderState = (headerState) => (dispatch) => {
    dispatch({
        type: SET_HEADER_STATE,
        headerState,
    });
};

export default (headerState) => store.dispatch(setHeaderState(headerState));
